import { USERS_ENDPOINTS } from "../../../utils/api/endpoints/usersEndpoints";

const PREFIX = '[currentLogoQuery]';

export const queryCurrentLogo = async () => {
  console.log(PREFIX, `Fetching Current Logo...`);
  const response = await USERS_ENDPOINTS.logo();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received Current Logo.`);
  return json as File;
};
